export function fromDateString(str: DateString): Date {
  return new Date(str);
}
